<style>
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-grow: 1;
  }
</style>

@let commonFiltersAreActive =
  $assignedToMeFilterIsActive() ||
  $hideCompletedRequestsFilterIsActive() ||
  $inWorkRequestsFilterIsActive() ||
  $todayRequestsFilterIsActive() ||
  $tomorrowRequestsFilterIsActive();

@let insideSheet = $insideSheet();
@let additionalFiltersButtons = additionalFiltersButtons$ | async;
@let mobileAdditionalFiltersButtons = mobileAdditionalFiltersButtons$ | async;
@let desktopTableColumns = $desktopTableColumns();

@if ($isMobile()) {
  <div class="flex flex-col h-full grow">
    <section class="mb-4 flex">
      @if (!insideSheet) {
        <button
          appearance="transparent"
          size="m"
          tuiButton
          class="requests-list-filter-button h-9! w-9! min-h-0! min-w-0! p-0! me-1.5"
          (click)="$toggleMobileFiltersSheet.emit()"
        >
          <x-svg-icon icon="x-icon::filter"></x-svg-icon>
        </button>
      }

      <section
        class="flex gap-1.5"
        [ngClass]="{
          'overflow-x-auto  no-scrollbar': !insideSheet,
          'flex-wrap': insideSheet,
        }"
      >
        @for (filter of mobileAdditionalFiltersButtons; track filter.title) {
          <ng-container
            [ngTemplateOutlet]="additionalFilterBtn"
            [ngTemplateOutletContext]="{
              filter,
              isDesktop: false,
            }"
          />
        }
        @if (insideSheet) {
          <ng-container
            [ngTemplateOutlet]="contractorOwnerButtons"
            [ngTemplateOutletContext]="{ isDesktop: false }"
          />
        } @else {
          <ng-container
            [ngTemplateOutlet]="activeContractorOwnerFilters"
            [ngTemplateOutletContext]="{ isDesktop: false }"
          />
        }
        @if ($showAssignedToMeFilter()) {
          <ng-container
            [ngTemplateOutlet]="filterBtn"
            [ngTemplateOutletContext]="{
              title: 'filters_buttons.assigned_to_me' | translate,
              active: $assignedToMeFilterIsActive(),
              click: showAssignedToMe.bind(this),
              isDesktop: false,
            }"
          />
        }
        @for (filter of commonFiltersButtons; track filter.title) {
          <ng-container
            [ngTemplateOutlet]="filterBtn"
            [ngTemplateOutletContext]="{
              title: filter.title | translate,
              active: filter.active(),
              click: filter.click,
              isDesktop: false,
            }"
          />
        }
        <button
          tuiChip
          class="h-9! x-font-body-5-bold-important"
          (click)="clearFilters()"
          [disabled]="!$filterIsActive() && !commonFiltersAreActive"
        >
          {{ 'filters_buttons.clear_all' | translate }}
          <tui-icon icon="@tui.x"></tui-icon>
        </button>
      </section>
    </section>
    <div class="flex flex-col h-full grow">
      <ng-content select="x-request-list-columns-filters"></ng-content>
      @if (insideSheet) {
        <footer class="mt-auto">
          <button
            tuiButton
            (click)="searchRequests()"
            appearance="primary"
            size="l"
            class="w-full mt-8"
            [disabled]="!$filterIsActive()"
          >
            {{ 'filters_buttons.apply' | translate }}
          </button>
        </footer>
      }
    </div>
  </div>
} @else {
  <section class="flex gap-1.5 flex-wrap items-center mb-1.5 mt-5">
    @if (!insideSheet) {
      <button
        appearance="transparent"
        size="m"
        tuiButton
        class="h-9! w-9! min-h-0! min-w-0! p-0! requests-list-filter-button"
        (click)="$toggleDesktopFiltersModal.emit()"
      >
        <x-svg-icon icon="x-icon::filter"></x-svg-icon>
      </button>
    }
    @if (insideSheet) {
      <ng-container
        [ngTemplateOutlet]="contractorOwnerButtons"
        [ngTemplateOutletContext]="{ isDesktop: true }"
      />
    } @else {
      <ng-container
        [ngTemplateOutlet]="activeContractorOwnerFilters"
        [ngTemplateOutletContext]="{ isDesktop: true }"
      />
    }
    @if ($showAssignedToMeFilter()) {
      <ng-container
        [ngTemplateOutlet]="filterBtn"
        [ngTemplateOutletContext]="{
          title: 'filters_buttons.assigned_to_me' | translate,
          active: $assignedToMeFilterIsActive(),
          click: showAssignedToMe.bind(this),
          isDesktop: true,
        }"
      />
    }
    @for (filter of commonFiltersButtons; track filter.title) {
      <ng-container
        [ngTemplateOutlet]="filterBtn"
        [ngTemplateOutletContext]="{
          title: filter.title | translate,
          active: filter.active(),
          click: filter.click,
          isDesktop: true,
        }"
      />
    }
    @for (filter of additionalFiltersButtons; track filter.title) {
      <ng-container
        [ngTemplateOutlet]="additionalFilterBtn"
        [ngTemplateOutletContext]="{
          filter,
          isDesktop: true,
        }"
      />
    }
    @if (
      $filterIsActive() ||
      commonFiltersAreActive ||
      additionalFiltersButtons?.length
    ) {
      <x-icon-button
        iconName="@tui.x"
        class="self-end"
        [size]="32"
        [clickFunction]="clearFilters.bind(this)"
        [backgroundPrimary]="false"
      />
    }
    <div class="ms-auto">
      <x-edit-desktop-table-button
        [tableColumns]="desktopTableColumns"
        (tableSettingsChanged)="$tableSettingsChanged.emit($event)"
      />
    </div>
  </section>
}

<ng-template
  #filterBtn
  let-title="title"
  let-active="active"
  let-click="click"
  let-isDesktop="isDesktop"
>
  <button
    tuiChip
    class="h-9! x-font-body-5-bold-important p-3.5! bg-(--tui-background-base-alt)!"
    [ngClass]="{
      'x-chip-active x-white': active,
      'bg-(--tui-background-base-alt)!': !isDesktop && !insideSheet,
      'bg-(--tui-background-base)!': isDesktop && insideSheet,
    }"
    (click)="click.call()"
  >
    {{ title }}
  </button>
</ng-template>

<ng-template #activeContractorOwnerFilters let-isDesktop="isDesktop">
  @if ($contractorFilterIsActive()) {
    <button
      tuiChip
      class="h-9! x-chip-active x-font-body-5-bold-important p-3.5! x-white"
      [ngClass]="{
        'bg-(--tui-background-base-alt)!': !isDesktop,
        'bg-(--tui-background-base)!': isDesktop,
      }"
      (click)="clearContractorFilter()"
    >
      {{ 'filters_buttons.contractor' | translate }}
      <tui-icon icon="@tui.x"></tui-icon>
    </button>
  }
  @if (
    $ownerFilterIsActive() &&
    (permissionService.canLogistViewScheduleOwners$ | async)
  ) {
    <button
      tuiChip
      class="h-9! x-chip-active x-font-body-5-bold-important p-3.5! x-white"
      [ngClass]="{
        'bg-(--tui-background-base-alt)!': !isDesktop,
        'bg-(--tui-background-base)!': isDesktop,
      }"
      (click)="clearOwnerFilter()"
    >
      {{ 'filters_buttons.owner' | translate }}
      <tui-icon icon="@tui.x"></tui-icon>
    </button>
  }
</ng-template>

<!-- Кнопки открытия модалок «Исполнитель» и «Заказчик» -->
<ng-template #contractorOwnerButtons let-isDesktop="isDesktop">
  <ng-container
    [ngTemplateOutlet]="filterBtn"
    [ngTemplateOutletContext]="{
      title: 'filters_buttons.contractor' | translate,
      active: $contractorFilterIsActive(),
      click: openContractorFilter,
      isDesktop,
    }"
  />
  <!-- «Заказчик» — только с правом logistViewScheduleOwners (как в старой системе) -->
  @if (permissionService.canLogistViewScheduleOwners$ | async) {
    <ng-container
      [ngTemplateOutlet]="filterBtn"
      [ngTemplateOutletContext]="{
        title: 'filters_buttons.owner' | translate,
        active: $ownerFilterIsActive(),
        click: openOwnerFilter,
        isDesktop,
      }"
    />
  }
</ng-template>

<ng-template #additionalFilterBtn let-filter="filter" let-isDesktop="isDesktop">
  <button
    tuiChip
    class="h-9! x-chip-active x-font-body-5-bold-important p-3.5! x-white"
    [tuiHint]="
      isDesktop
        ? ('filters_buttons.' + filter.title | translate) +
          ': ' +
          getFilterHintValue(filter)
        : ''
    "
    [ngClass]="{
      'bg-(--tui-background-base-alt)!': !isDesktop && !insideSheet,
      'bg-(--tui-background-base)!': isDesktop && insideSheet,
      'max-w-[300px]!': isDesktop,
    }"
  >
    <span [class.min-w-0]="isDesktop" [class.truncate]="isDesktop">
      {{ ('filters_buttons.' + filter.title | translate) + ': ' }}
      {{ getFilterDisplayValue(filter) }}
    </span>
    @if (filter.removable) {
      <button
        iconStart="@tui.x"
        tuiIconButton
        size="xs"
        appearance="icon"
        class="ms-2"
        (click)="removeAdditionalFilter(filter)"
      ></button>
    }
  </button>
</ng-template>
